<template>
  <input
    v-model.lazy="localValue"
    ref="input"
    class="form-control value-editor"
    :placeholder="focused ? '' : valueOrFallback"
    v-tooltip="localValidationData && !localValidationData.isValid && localValidationData.feedback"
    :class="{
      'border-warning': localValidationData && !localValidationData.isValid && localValidationData.type == 'warning',
      'border-danger': localValidationData && !localValidationData.isValid && localValidationData.type == 'error'
    }"
    :readonly="!canWrite"
    @focus="focused = true"
    @blur="focused = false"
    @keyup.enter="localValue = $refs.input.value" />
</template>
<script>
import moment from "moment";
import authorizationProvider from "../../services/permissions/permissionEngine";

export default {
  props: ["value", "valueOrFallback", "language", "validationData", "dataType", "authorizationContext"],
  data() {
    return {
      localValue: "",
      focused: false
    };
  },
  computed: {
    canWrite() {
      if (this.authorizationContext) {
        return authorizationProvider.canWrite(this.authorizationContext);
      }
      return true;
    },
    localValidationData() {
      if (this.validationData && !this.validationData.isValid && this.validationData.type == "error") {
        return this.validationData;
      } else if (this.dataTypeValidationData) {
        return this.dataTypeValidationData;
      } else {
        return this.validationData;
      }
    },
    dataTypeValidationData() {
      const format = this.language && this.language.shortDateFormat ? this.language.shortDateFormat.toUpperCase() : null;
      if (this.localValue && this.localValue != "" && format && format != "") {
        if (!moment(this.localValue, format).isValid()) {
          return {
            isValid: false,
            feedback: this.$t("validation.dataTypeNotDate") + " " + this.$t("validation.invalidDateFormat", { format: format }),
            type: "warning"
          };
        } else if (!moment(this.localValue, format, true).isValid()) {
          return {
            isValid: false,
            feedback: this.$t("validation.invalidDateFormat", { format: format }) + " " + this.$t("validation.timeInfoNotSupported", { format: format }),
            type: "warning"
          };
        }
      }
      return null;
    }
  },
  watch: {
    value: {
      immediate: true,
      handler(nv) {
        if (nv != this.localValue) this.localValue = nv;
      }
    },
    localValue(nv) {
      this.$emit("input", nv);
    }
  }
};
</script>
